import { jwtDecode } from 'jwt-decode';
import { tokenHintType } from '../constants';
const nowSec = ()=>Math.floor(Date.now() / 1000);
export const createAccessTokenCache = ()=>{
    let token;
    let expiresAt;
    const getToken = ()=>token;
    const setToken = (newToken, /* for testing purposes only */ computeExpiresAt = (newToken)=>nowSec() + newToken?.expires_in)=>{
        token = newToken;
        if (token) {
            expiresAt = newToken?.expires_in ? computeExpiresAt(newToken) : undefined;
            try {
                const accessToken = token?.[tokenHintType.accessToken];
                if (accessToken) {
                    token.decoded_token = jwtDecode(accessToken);
                }
            } catch (_e) {}
        }
    };
    const getUnexpiredToken = (expiryAdjustmentSeconds = 60)=>{
        if (!token) {
            return;
        }
        if (expiresAt && expiresAt - expiryAdjustmentSeconds > nowSec()) {
            return token;
        } else {
            setToken(undefined);
        }
    };
    const getExpiresAt = ()=>expiresAt;
    return {
        getToken,
        getUnexpiredToken,
        setToken,
        getExpiresAt
    };
};
export const createRefreshTokenCache = ()=>{
    let token;
    const getToken = ()=>token;
    const setToken = (newToken)=>{
        token = newToken;
    };
    return {
        getToken,
        setToken
    };
};
